module.exports = __webpack_public_path__ + "static/media/video.0cf5c2be.svg";